class LancamentoModal {
    $onInit() {
        this.nfe = this.resolve.nfe
        this.lancamento = this.resolve.lancamento
    }
}

angular.module('eficienciaFiscalModule')
    .component('lancamentoModal', {
        controller: [LancamentoModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <modal title="Detalhes do Lançamento" close="$ctrl.close">
            <modal-body>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table table-bordered table-hover table-condensed">
                            <tr>
                                <th class="text-center" colspan="2">Dados da NF-e</th>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Número</th>
                                <td>{{ $ctrl.nfe.numero }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Valor</th>
                                <td>{{ $ctrl.nfe.valor | currency }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Entrada</th>
                                <td>{{ $ctrl.nfe.emissao | date }}</td>
                            </tr>
                            <tr>
                                <th class="text-center" colspan="2">Dados do remetente</th>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Razão social</th>
                                <td>{{ $ctrl.nfe.emitente.nome }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">CNPJ</th>
                                <td>{{ $ctrl.nfe.emitente.cpfCnpj | cpfCnpj }}</td> 
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">UF</th>
                                <td>{{ $ctrl.nfe.emitente.uf }}</td>
                            </tr>
                            <tr>
                                <th class="text-center" colspan="2">Dados do conhecimento</th>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Frete</th>
                                <td>{{ $ctrl.lancamento.freteTipo || '--' }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Número</th>
                                <td>{{ $ctrl.lancamento.freteNumero || '--' }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Valor</th>
                                <td>{{ ($ctrl.lancamento.freteValor | currency) || '--' }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table table-bordered table-hover table-condensed">
                            <tr>
                                <th class="text-center" colspan="2">Demonstrativo de cálculo do ICMS a recolher</th>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Total do item</th>
                                <td>{{ $ctrl.lancamento.valorTotalItem | currency }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Produto</th>
                                <td>{{ $ctrl.lancamento.produto }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Percentual</th>
                                <td>{{ $ctrl.lancamento.percentual | currency:'' }} %</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Valor agregado</th>
                                <td>{{ ($ctrl.lancamento.valorAgregado | currency) || '--' }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Base de cálculo</th>
                                <td>{{ $ctrl.lancamento.baseCalculo | currency }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Alíquota</th>
                                <td>{{ $ctrl.lancamento.aliquota | currency:'' }} %</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Débito</th>
                                <td>{{ $ctrl.lancamento.debito | currency }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Crédito</th>
                                <td>{{ $ctrl.lancamento.credito | currency }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">ICMS a recolher</th>
                                <td>{{ $ctrl.lancamento.icmsRecolher | currency }}</td>
                            </tr>
                            <tr>
                                <th class="text-right" width="40%">Número da Guia Resumo</th>
                                <td class="text-middle">{{ $ctrl.lancamento.guiaResumo }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </modal-body>
            <modal-footer>
                <button class="btn btn-default" type="button" ng-click="$ctrl.close()">Fechar</button>
            </modal-footer>
        </modal>
        `
    })
